import { Rainbow } from '@indot/rainbowvis';

export default (cellWidth, listingPrice, minPrice, maxPrice) => ({
    totalCells: 0,
    gradientElements: 0,
    rainbow: null,

    init() {
        let wrapper = this.$refs.graphWrapper;
        let availableWidth = wrapper.offsetWidth - (wrapper.offsetWidth % cellWidth);
        this.totalCells = availableWidth / cellWidth;

        this.rainbow = new Rainbow();
        this.rainbow.setNumberRange(1, this.totalCells);
        this.rainbow.setSpectrum('#4ECED3', '#F0D354', '#B32025');

        let percent = parseInt(
            ((Math.max(Math.min(listingPrice, maxPrice), minPrice) - minPrice) * 100) / (maxPrice - minPrice),
        );
        this.gradientElements = parseInt((this.totalCells * percent) / 100);
    },

    getCellStyle(i) {
        return i <= this.gradientElements && this.gradientElements <= this.totalCells
            ? `background-color: #${this.rainbow.colourAt(i)};`
            : '';
    },
});
